import styled from "styled-components";

const NoTranslate = styled.span.attrs({ translate: "no" })``;

export default NoTranslate;
